<template>
  <section class="layer-section sku-installment" v-if="antInstallment && antInstallment.perInstallmentInfoList">
    <h3 class="section-title">花呗分期</h3>
    <div class="section-content instalment">
      <div class="btn-wrapper" v-for="(installmentInfo, index) in antInstallment.perInstallmentInfoList" :key="index">
        <div
          class="section-btn"
          :class="{ checked: fqNum == installmentInfo.num }"
          @click="toggleInstallment(installmentInfo)"
        >
          <p class="name">
            <dfn>&yen;</dfn>
            {{ installmentInfo.perPay }}x{{ installmentInfo.num }}期
          </p>
          <p class="subname" :class="{ 'red-color': !installmentInfo.userPerFeePay }">
            <template v-if="installmentInfo.userPerFeePay">手续费{{ installmentInfo.userPerFeePay }}元/期</template>
            <template v-else>免息</template>
          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getInstallmentReq } from './api'

export default {
  name: 'sku-installment',
  props: {
    skuId: [Number, String],
    money: Number,
    fqNum: Number // 选中的分期数
  },
  data() {
    return {
      antInstallment: null, // 当前选择的sku对应的分期信息
      antInstallmentList: {} // 所有sku的花呗分期信息，以skuId + money 作为key
    }
  },
  computed: {
    // 分期的依赖，如果这些依赖有变化，需要重新请求分期信息
    dep() {
      return {
        skuId: this.skuId,
        money: this.money
      }
    }
  },
  watch: {
    // skuId和money变化时重新请求分期信息
    dep() {
      this.$nextTick(this.getInstallmentInfo)
    }
  },
  created() {
    this.getInstallmentInfo()
  },
  methods: {
    // 获取花呗信息
    getInstallmentInfo() {
      let key = this.skuId + '#' + this.money
      let current = this.antInstallmentList[key]
      // 当花呗信息已经存在时，直接切换成当前的
      if (!current) {
        getInstallmentReq({
          skuId: this.skuId || this.skuInfo.id,
          money: this.money
        }).then(
          data => {
            this.$set(this.antInstallmentList, key, data && data.antInstallment)
            this.antInstallment = data && data.antInstallment
          },
          () => {
            this.antInstallment = null
            // this.$toast(err && err.msg)
          }
        )
      } else {
        this.antInstallment = current
      }
    },
    // 切换分期信息
    toggleInstallment(installmentInfo) {
      this.$emit('fqNumChange', installmentInfo.num == this.fqNum ? 0 : installmentInfo.num)
    }
  }
}
</script>
